import { useState } from "react";
import { Sparkles } from "lucide-react";
import { assetUrl } from "@/lib/gallery";

export function TexturePanel({ textures = [], index }) {
  if (!textures.length) return null;
  return (
    <div className="mb-6" data-testid={`textures-${index}`}>
      <div className="eyebrow mb-2">Textures & finishes</div>
      <div className="grid grid-cols-3 gap-2">
        {textures.slice(0, 3).map((t, j) => (
          <div key={`${t.material}-${j}`} data-testid={`texture-${index}-${j}`}>
            <div className="aspect-square bg-stone-100 overflow-hidden border" style={{ borderColor: "#E5E5DF" }}>
              {t.url ? <img src={assetUrl(t.url)} alt={`${t.material} texture`} className="w-full h-full object-cover" loading="lazy" />
                : <div className="w-full h-full flex items-center justify-center text-[10px] text-stone-400 font-mono-lab uppercase text-center px-2">{t.category || "swatch"}</div>}
            </div>
            <div className="text-xs mt-1 leading-snug">{t.material}</div>
            {(t.finish || t.feel) && <div className="text-[11px] text-stone-500 leading-snug">{[t.finish, t.feel].filter(Boolean).join(" · ")}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

export function IdeaBrief({ index, value, busy, onRegenerate, label = "Your ideas for this room", placeholder = "e.g. Keep the fluted oak wall, swap the sofa for a curved bouclé sectional, warmer evening lighting, one large abstract artwork…", cta = "Regenerate with my ideas" }) {
  const [brief, setBrief] = useState(value || "");
  return (
    <div className="border border-stone-200 bg-white/70 p-4 mb-6" data-testid={`brief-${index}`}>
      <div className="eyebrow mb-2">{label}</div>
      <textarea value={brief} onChange={e => setBrief(e.target.value)} rows={3} placeholder={placeholder} data-testid={`brief-input-${index}`}
        className="w-full text-sm border border-stone-300 p-3 bg-white focus:outline-none focus:border-black" />
      <div className="flex items-center justify-between gap-3 mt-2">
        <div className="text-[11px] text-stone-400">The AI re-composes text, palette, textures and the render around your notes.</div>
        <button type="button" onClick={() => onRegenerate(brief)} disabled={busy} data-testid={`brief-regen-${index}`}
          className="inline-flex items-center gap-2 bg-black text-white text-xs px-3 py-2 disabled:opacity-50 whitespace-nowrap">
          <Sparkles size={12} className={busy ? "animate-pulse" : ""} /> {busy ? "Working…" : cta}
        </button>
      </div>
    </div>
  );
}
